import { useEffect } from 'react';

import { getIsTimerIntroductionSkipped } from '../../../../db/timer';

export interface UseIntroduction {
  goToNextStep: () => void;
}

const useIntroduction = ({ goToNextStep }: UseIntroduction) => {
  useEffect(() => {
    const skipIntroduction: boolean = getIsTimerIntroductionSkipped();

    if (!skipIntroduction) return;

    goToNextStep();
  }, []);
};

export default useIntroduction;
